'use client';

import { useRouter } from 'next/navigation';
import LostPassword from '@organisms/LostPassword/LostPassword';
import paths from '@constants/paths';
import HomePageClient from '@root/app/HomePageClient';
import useIsOwnRoute from '@hooks/useIsOwnRoute';

export const LOST_PASSWORD_PAGE_ROUTES = [
  paths.LOST_PASSWORD,
  paths.LOST_PASSWORD_B2B,
  paths.RESET_PASSWORD,
  paths.RESET_PASSWORD_B2B,
];

interface Props {
  tab?: 'b2c' | 'b2b';
}

export default function LostPasswordPageClient({ tab = 'b2c' }: Props) {
  const router = useRouter();

  const handleClose = () => {
    // Hard-load only (email link, refresh), so push to a known destination.
    router.push('/');
  };

  if (!useIsOwnRoute(LOST_PASSWORD_PAGE_ROUTES)) {
    return <HomePageClient />;
  }

  return (
    <>
      <HomePageClient />
      <LostPassword onCloseHandler={handleClose} tab={tab} />
    </>
  );
}
